/**
 * Custom @xyflow/react edge for KG visualization.
 * Colors edges by relationship type using KG_RELATIONSHIP_COLORS.
 */

import { memo } from 'react'
import { BaseEdge, getStraightPath, type EdgeProps } from '@xyflow/react'
import type { KgFlowEdgeData } from './useSpiralLayout'

function KgFlowEdgeComponent({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
  selected,
}: EdgeProps & { data?: KgFlowEdgeData }) {
  const [edgePath] = getStraightPath({ sourceX, sourceY, targetX, targetY })
  const color = data?.color || '#475569'

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{
        stroke: color,
        strokeWidth: selected ? 2.5 : 1.5,
        opacity: selected ? 1 : 0.6,
      }}
    />
  )
}

export const KgFlowEdge = memo(KgFlowEdgeComponent)
